import React, { useEffect, useState } from 'react';
import { obtenerEmpresas } from '../services/empresasService';
import AgregarEmpresa from '../components/AgregarEmpresa';

export default function EmpresasPage() {
  const [empresas, setEmpresas] = useState([]);

  const cargarEmpresas = async () => {
    try {
      const data = await obtenerEmpresas();
      setEmpresas(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    cargarEmpresas();
  }, []);

  const handleEmpresaAgregada = () => {
    cargarEmpresas();
  };

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Empresas</h1>

      <AgregarEmpresa onEmpresaAgregada={handleEmpresaAgregada} />

      <div className="mt-6">
        <h2 className="text-xl font-bold mb-2">Lista de Empresas</h2>
        <ul className="divide-y divide-gray-300">
          {empresas.map((emp) => (
            <li key={emp.id} className="py-2">
              <div className="font-semibold">{emp.nombre}</div>
              {emp.descripcion && <div className="text-sm text-gray-700">{emp.descripcion}</div>}
              {emp.direccion && <div className="text-sm text-gray-700">Dirección: {emp.direccion}</div>}
              {(emp.contacto_nombre || emp.contacto_email || emp.contacto_telefono) && (
                <div className="text-sm text-gray-700">
                  Contacto: {emp.contacto_nombre} ({emp.contacto_email}, {emp.contacto_telefono})
                </div>
              )}
              {(emp.rfc || emp.razon_social || emp.direccion_fiscal) && (
                <div className="text-sm text-gray-700">
                  RFC: {emp.rfc} | Razón Social: {emp.razon_social} | Dirección Fiscal: {emp.direccion_fiscal}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}